module.exports = "<div class='terms z-body-text' [innerHtml]='data'></div>\n"